import { EVENT_TYPE } from '@lighthouse/core'
import type { FlowNode, FlowNodeResultADT } from '@lighthouse/shared'
import { waitFor } from '@lighthouse/shared'

import type { ExecuteActionParams } from '../type'

export const handleGoBack = async (node: FlowNode, params: ExecuteActionParams): Promise<undefined | FlowNodeResultADT> => {
    const { actionEvents, eventType } = params

    if (actionEvents && eventType !== EVENT_TYPE.LOAD && eventType !== EVENT_TYPE.LOAD_DATA) {
        const { closePage } = actionEvents

        closePage()

        await waitFor(300)
    }

    return {
        type: 'record',
        success: true
    }
}
